// import React, { useEffect, useRef, useMemo, useState } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { useLanguage } from '../component/LanguageProvider';
// import { Link } from 'react-router-dom';
// import SEO from '../component/SEO';
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

// // Images
// import ResidencyImg from '../Images/residency_service.png';
// import CompanyImg from '../Images/company_service.png';
// import RelocationImg from '../Images/relocation_service.png';
// import JetImg from '../Images/private_jet_interior_luxury_1778327320105.png';
// import PropertyImg from '../Images/luxury_real_estate_villa_spain_1778327334195.png';
// import ConciergeImg from '../Images/vip_concierge_service_luxury_watch_keys_1778327352793.png';
// import EmptyLegImg from '../Images/empty_leg_jet_sunset_1778327443324.png';
// import VIPTerminalImg from '../Images/vip_airport_terminal_lounge_1778327462155.png';
// import MedEvacImg from '../Images/medical_evacuation_jet_ambulance_1778327484064.png';
// import HeroImg from '../Images/service_page_hero_luxury_jet_top_view_1778327953777.png';

// gsap.registerPlugin(ScrollTrigger);

// export const Ourservicepage = () => {
//   const { currentLang, isInitialized } = useLanguage();
//   const [activeTab, setActiveTab] = useState(0);
//   const containerRef = useRef(null);
//   const gridRef = useRef(null);

//   const isAR = currentLang === 'ar';

//   const translations = {
//     en: {
//       pageTitle: 'Premium Services | FlyVia Global Lifestyle',
//       heroTitle: 'Our Services',
//       heroSubtitle: 'Comprehensive pathways for residency, business, and elite life in Europe.',
//       breadcrumbHome: 'Home',
//       breadcrumbCurrent: 'Services',
//       aviationHeader: 'Aviation Portfolio',
//       relocationHeader: 'Relocation Experts',
//       lifestyleHeader: 'Global Lifestyle',
//       services: {
//         jet: { title: 'Private Jet Charter', desc: 'Bespoke flight solutions for those who value time and privacy.' },
//         emptyLeg: { title: 'Empty Leg Flights', desc: 'Premium travel opportunities on repositioning aircraft at exceptional value.' },
//         commercial: { title: 'Commercial Flight', desc: 'Experience a distinctive blend of efficiency and comfort.' },
//         vipTerminal: { title: 'VIP Terminal Access', desc: 'Seamless, private airport experiences at the world\'s most exclusive hubs.' },
//         medEvac: { title: 'Medical Evacuation', desc: 'Urgent, professional air ambulance services with specialized care.' },
//         cargo: { title: 'Private Cargo', desc: 'Secure, high-priority logistics for valuable and time-sensitive assets.' },
//         ads: { title: 'Aerial Advertising', desc: 'Elevate your brand visibility with Swift Jet\'s unique aerial displays.' },
//         // tours: { title: 'Flight Sightseeing', desc: 'Discover breathtaking landscapes from a unique aerial perspective.' },
//         residency: { title: 'Spain Residency', desc: 'Expert navigation through Spanish residency and legal pathways.' },
//         nomad: { title: 'Digital Nomad Visa', desc: 'Strategic support for remote professionals seeking life in Spain.' },
//         formation: { title: 'Corporate Setup', desc: 'Complete business establishment and administrative support in Europe.' },
//         relocation: { title: 'Elite Relocation', desc: 'Dedicated management for a smooth transition into your new life.' },
//         education: { title: 'Education & Family', desc: 'Planning for the future with family settlement and school placements.' },
//         schengen: { title: 'Schengen Support', desc: 'Streamlined visa review and preparation for European travel.' },
//         property: { title: 'Luxury Real Estate', desc: 'Exclusive access to premium properties in the Mediterranean.' },
//         concierge: { title: 'VIP Concierge', desc: 'Lifestyle management and bespoke arrangements for the elite.' }
//       }
//     },
//     ar: {
//       pageTitle: 'الخدمات المتميزة | FlyVia أسلوب الحياة العالمي',
//       heroTitle: 'خدماتنا',
//       heroSubtitle: 'مسارات شاملة للإقامة، والأعمال، والحياة النخبوية في أوروبا.',
//       breadcrumbHome: 'الرئيسية',
//       breadcrumbCurrent: 'خدماتنا',
//       aviationHeader: 'محفظة الطيران',
//       relocationHeader: 'خبراء الانتقال',
//       lifestyleHeader: 'أسلوب الحياة العالمي',
//       services: {
//         jet: { title: 'طيران خاص', desc: 'حلول طيران مخصصة لأولئك الذين يقدرون الوقت والخصوصية.' },
//         emptyLeg: { title: 'رحلات Empty Leg', desc: 'فرص سفر متميزة على الطائرات المعاد تموضعها بقيمة استثنائية.' },
//         commercial: { title: 'رحلات تجارية', desc: 'مزيج مميز من الكفاءة والراحة لأهم الوجهات.' },
//         vipTerminal: { title: 'صالة كبار الشخصيات', desc: 'تجارب مطار خاصة وسلسة في أكثر المراكز حصرية في العالم.' },
//         medEvac: { title: 'الإخلاء الطبي', desc: 'خدمات إسعاف جوي احترافية وعاجلة مع رعاية متخصصة.' },
//         cargo: { title: 'شحن خاص', desc: 'خدمات لوجستية آمنة وعالية الأولوية للأصول القيمة.' },
//         ads: { title: 'إعلانات جوية', desc: 'ارتقِ برؤية علامتك التجارية مع عروضنا الجوية الفريدة.' },
//         // tours: { title: 'جولات طيران', desc: 'اكتشف المناظر الطبيعية الخلابة من منظور جوي فريد.' },
//         residency: { title: 'الإقامة في إسبانيا', desc: 'توجيه خبير عبر مسارات الإقامة والقوانين الإسبانية.' },
//         nomad: { title: 'فيزا الرحالة الرقمي', desc: 'دعم استراتيجي للمهنيين عن بعد الساعين للحياة في إسبانيا.' },
//         formation: { title: 'تأسيس الشركات', desc: 'دعم كامل لتأسيس الأعمال والإدارة في أوروبا.' },
//         relocation: { title: 'الانتقال المتميز', desc: 'إدارة مخصصة لانتقال سلس إلى حياتك الجديدة.' },
//         education: { title: 'التعليم والعائلة', desc: 'تخطيط للمستقبل مع استقرار العائلة والالتحاق بالمدارس.' },
//         schengen: { title: 'دعم الشنجن', desc: 'مراجعة وتجهيز تأشيرات السفر الأوروبية بسلاسة.' },
//         property: { title: 'عقارات فاخرة', desc: 'وصول حصري للعقارات المتميزة في البحر المتوسط.' },
//         concierge: { title: 'كونسيرج VIP', desc: 'إدارة أسلوب الحياة وترتيبات مخصصة للنخبة.' }
//       }
//     }
//   };

//   const t = (path) => {
//     const keys = path.split('.');
//     let result = translations[isAR ? 'ar' : 'en'];
//     for (const key of keys) {
//       result = result?.[key];
//     }
//     return result || path;
//   };

//   const serviceCategories = useMemo(() => [
//     {
//       header: t('aviationHeader'),
//       items: [
//         { id: 'jet', img: JetImg, title: t('services.jet.title'), desc: t('services.jet.desc') },
//         { id: 'emptyLeg', img: EmptyLegImg, title: t('services.emptyLeg.title'), desc: t('services.emptyLeg.desc') },
//         { id: 'commercial', img: EmptyLegImg, title: t('services.commercial.title'), desc: t('services.commercial.desc') },
//         { id: 'vipTerminal', img: VIPTerminalImg, title: t('services.vipTerminal.title'), desc: t('services.vipTerminal.desc') },
//         { id: 'medEvac', img: MedEvacImg, title: t('services.medEvac.title'), desc: t('services.medEvac.desc') },
//         { id: 'cargo', img: JetImg, title: t('services.cargo.title'), desc: t('services.cargo.desc') },
//         { id: 'ads', img: JetImg, title: t('services.ads.title'), desc: t('services.ads.desc') },
//         // { id: 'tours', img: EmptyLegImg, title: t('services.tours.title'), desc: t('services.tours.desc') }
//       ]
//     },
//     {
//       header: t('relocationHeader'),
//       items: [
//         { id: 'residency', img: ResidencyImg, title: t('services.residency.title'), desc: t('services.residency.desc') },
//         { id: 'nomad', img: RelocationImg, title: t('services.nomad.title'), desc: t('services.nomad.desc') },
//         { id: 'formation', img: CompanyImg, title: t('services.formation.title'), desc: t('services.formation.desc') },
//         { id: 'relocation', img: RelocationImg, title: t('services.relocation.title'), desc: t('services.relocation.desc') },
//         { id: 'education', img: ResidencyImg, title: t('services.education.title'), desc: t('services.education.desc') },
//         { id: 'schengen', img: RelocationImg, title: t('services.schengen.title'), desc: t('services.schengen.desc') }
//       ]
//     },
//     {
//       header: t('lifestyleHeader'),
//       items: [
//         { id: 'property', img: PropertyImg, title: t('services.property.title'), desc: t('services.property.desc') },
//         { id: 'concierge', img: ConciergeImg, title: t('services.concierge.title'), desc: t('services.concierge.desc') }
//       ]
//     }
//   ], [currentLang]);

//   useEffect(() => {
//     if (!isInitialized) return;
//     const ctx = gsap.context(() => {
//       gsap.from('.reveal-up', { y: 30, opacity: 0, stagger: 0.1, duration: 0.8, ease: 'power2.out' });

//       gsap.from('.os-card-anim', {
//         y: 40,
//         opacity: 0,
//         stagger: 0.1,
//         duration: 0.8,
//         ease: 'power3.out',
//         clearProps: "all"
//       });
//     }, containerRef);
//     return () => ctx.revert();
//   }, [isInitialized, activeTab]);

//   if (!isInitialized) return null;

//   return (
//     <div className="ourservices-page" ref={containerRef} dir={isAR ? 'rtl' : 'ltr'}>
//       <SEO
//         title={t('heroTitle')}
//         description={t('heroSubtitle')}
//         keywords={isAR ? 'خدمات طيران, إقامة إسبانيا, تأسيس شركات, كونسيرج, رحلات خاصة' : 'aviation services, Spain residency, company setup, VIP concierge, private jets Europe'}
//       />

//       <style>{`
//         .ourservices-page {
//           background: #fff;
//           color: #07111f;
//           font-family: var(--font-primary);
//         }

//         .page-banner {
//           position: relative;
//           height: 65vh;
//           min-height: 400px;
//           background:
//             linear-gradient(rgba(7, 17, 31, 0.75), rgba(7, 17, 31, 0.8)),
//             url(${HeroImg});
//           background-size: cover;
//           background-position: center;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           text-align: center;
//           color: #fff;
//           clip-path: polygon(0 0, 100% 0, 100% 88%, 50% 100%, 0 88%);
//           margin-bottom: 40px;
//         }

//         @media (max-width: 768px) {
//           .page-banner {
//             height: 90vh !important;
//             min-height: 600px !important;
//           }
//         }

//         .banner-content h1 {
//           font-family: var(--font-heading);
//           font-size: clamp(40px, 6vw, 72px);
//           font-weight: 300;
//           margin-bottom: 15px;
//           text-transform: uppercase;
//           letter-spacing: 4px;
//         }

//         .breadcrumbs {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 12px;
//           font-family: var(--font-secondary);
//           font-size: 12px;
//           margin-top: 20px;
//           text-transform: uppercase;
//           letter-spacing: 0.2em;
//           opacity: 0.7;
//           color: #fff !important;
//           text-decoration: none !important;
//           opacity: 0.6 !important;
//           transition: 0.3s !important;
//         }

//         /* Modern Tabs Styling */
//         .services-tabs-container {
//           display: flex;
//           justify-content: center;
//           margin: 40px 0 80px;
//           padding: 0 15px;
//         }

//         .services-tabs-nav {
//           display: flex;
//           background: #f8fafc;
//           padding: 8px;
//           border-radius: 100px;
//           gap: 8px;
//           border: 1px solid #e2e8f0;
//           box-shadow: 0 10px 30px -5px rgba(0,0,0,0.05);
//           flex-wrap: wrap;
//           justify-content: center;
//           margin:auto !important;
//         }

//         .tab-btn {
//           background: transparent;
//           border: none;
//           font-family: var(--font-secondary);
//           font-size: 12px;
//           font-weight: 700;
//           text-transform: uppercase;
//           letter-spacing: 2px;
//           color: #94a3b8;
//           padding: 14px 35px;
//           border-radius: 100px;
//           transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
//           cursor: pointer;
//           position: relative;
//           z-index: 1;
//         }

//         .tab-btn:hover {
//           color: #475569;
//         }

//         .tab-btn.active {
//           background: #ae0001;
//           color: #fff;
//           box-shadow: 0 10px 20px -5px rgba(174, 0, 1, 0.3);
//         }

//         @media (max-width: 768px) {
//           .tab-btn {
//             padding: 8px 15px;
//             font-size: 10px;
//             letter-spacing: 1px;
//             flex: 1 1 auto;
//           }
//           .services-tabs-nav {
//             gap: 4px;
//             padding: 4px;
//             border-radius: 20px;
//           }
//           // .page-banner {
//           //   height: 30vh;
//           //   min-height: 250px;
//           // }
//           .banner-content h1 {
//             font-size: 32px;
//             letter-spacing: 2px;
//           }
//         }

//         .os-card {
//           position: relative;
//           padding: 15px;
//           text-align: center;
//           margin-bottom: 50px;
//           transition: transform 0.4s ease;
//         }

//         .os-frame {
//           position: absolute;
//           top: 50px;
//           left: 5px;
//           right: 5px;
//           bottom: 10px;
//           border: 1px solid rgba(174, 0, 1, 0.1);
//           z-index: 0;
//           transition: all 0.4s ease;
//         }
//         .os-card:hover .os-frame { top: 5px; border-color: rgba(174, 0, 1, 0.4); }

//         .os-image-wrapper {
//           position: relative;
//           z-index: 1;
//           width: 100%;
//           aspect-ratio: 3/4;
//           overflow: hidden;
//           margin-bottom: 20px;
//           box-shadow: 0 15px 30px rgba(0,0,0,0.08);
//         }
//         @media (max-width: 768px) {
//           .os-image-wrapper {
//             aspect-ratio: 16/9;
//           }
//         }
//         .os-image-wrapper img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform 1.2s ease;
//         }
//         .os-card:hover .os-image-wrapper img { transform: scale(1.08); }

//         .os-card-title {
//           font-family: var(--font-heading);
//           font-size: 22px;
//           color: #07111f;
//           margin-top: 15px;
//           font-weight: 300;
//         }

//         .os-card-desc {
//           font-family: var(--font-secondary);
//           font-size: 13px;
//           color: #64748b;
//           margin-top: 8px;
//           line-height: 1.6;
//           max-width: 90%;
//           margin-inline: auto;
//         }
//       `}</style>

//       <section className="page-banner">
//         <Container className="banner-content reveal-up">
//           <h1>{t('heroTitle')}</h1>
//           <div className="breadcrumbs">
//             <Link to="/" className="!text-white !no-underline">{t('breadcrumbHome')}</Link>
//             {isAR ? <FaArrowLeft /> : <FaArrowRight />}
//             <span className="!text-white !no-underline">{t('breadcrumbCurrent')}</span>
//           </div>
//         </Container>
//       </section>

//       <Container>
//         <div className="services-tabs-nav !w-fit !justify-center mx-auto reveal-up">
//           {serviceCategories.map((cat, idx) => (
//             <button
//               key={idx}
//               className={`tab-btn ${activeTab === idx ? 'active' : ''}`}
//               onClick={() => setActiveTab(idx)}
//             >
//               {cat.header}
//             </button>
//           ))}
//         </div>

//         <div className="tab-content-grid">
//           <Row>
//             {serviceCategories[activeTab].items.map((item, i) => (
//               <Col lg={4} md={6} key={item.id} className="os-card-anim">
//                 <Link to={`/service/${item.id}`} style={{ textDecoration: 'none' }}>
//                   <div className="os-card">
//                     <div className="os-frame"></div>
//                     <div className="os-image-wrapper">
//                       <img src={item.img} alt={item.title} />
//                     </div>
//                     <h3 className="os-card-title">{item.title}</h3>
//                     <p className="os-card-desc">{item.desc}</p>
//                   </div>
//                 </Link>
//               </Col>
//             ))}
//           </Row>
//         </div>
//       </Container>
//     </div>
//   );
// };

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLanguage } from "../component/LanguageProvider";
import SEO from "../component/SEO";

import CompanyImg from "../Images/company_service.png";
import PropertyImg from "../Images/luxury_real_estate_villa_spain_1778327334195.png";
import RelocationImg from "../Images/relocation_service.png";
import ResidencyImg from "../Images/residency_service.png";
import HeroImg from "../Images/service_page_hero_luxury_jet_top_view_1778327953777.png";
import ConciergeImg from "../Images/vip_concierge_service_luxury_watch_keys_1778327352793.png";

gsap.registerPlugin(ScrollTrigger);

export const Ourservicepage = () => {
  const { currentLang, isInitialized } = useLanguage();
  const [activeTab, setActiveTab] = useState(0);
  const containerRef = useRef(null);

  const isAR = currentLang === "ar";

  const translations = {
    en: {
      pageTitle: "Premium Services | FlyVia Global Lifestyle",
      heroTitle: "Our Services",
      heroSubtitle:
        "Comprehensive pathways for residency, business, and elite life in Europe.",
      breadcrumbHome: "Home",
      breadcrumbCurrent: "Services",
      aviationHeader: "Aviation Portfolio",
      relocationHeader: "Relocation Experts",
      lifestyleHeader: "Global Lifestyle",
      travelHeader: "Travel & Tourism",
      services: {
        jet: {
          title: "Private Jet Charter",
          desc: "Bespoke flight solutions for those who value time and privacy.",
        },
        emptyLeg: {
          title: "Empty Leg Flights",
          desc: "Premium travel opportunities on repositioning aircraft at exceptional value.",
        },
        commercial: {
          title: "Commercial Flight",
          desc: "Experience a distinctive blend of efficiency and comfort.",
        },
        medEvac: {
          title: "Medical Evacuation",
          desc: "Urgent, professional air ambulance services with specialized care.",
        },
        cargo: {
          title: "Private Cargo",
          desc: "Secure, high-priority logistics for valuable and time-sensitive assets.",
        },
        ads: {
          title: "Aerial Advertising",
          desc: "Elevate your brand visibility with Swift Jet's unique aerial displays.",
        },
        flightSightseeingTour: {
          title: "Flight Sightseeing Tour",
          desc: "Experience Egypt’s wonders from above across Cairo, the Pyramids, Luxor, Gouna, and Hurghada.",
        },
        almazaVipTerminal: {
          title: "Almaza VIP Terminal",
          desc: "Exclusive private jet departure and arrival services with privacy, smooth access, and a discreet VIP experience.",
        },
        flightCrewTraining: {
          title: "Flight Crew Training",
          desc: "Structured aviation training for pilots, technicians, and cabin crew covering safety, operations, and service readiness.",
        },
        residency: {
          title: "Spain Residency",
          desc: "Expert navigation through Spanish residency and legal pathways.",
        },
        nomad: {
          title: "Digital Nomad Visa",
          desc: "Strategic support for remote professionals seeking life in Spain.",
        },
        formation: {
          title: "Corporate Setup",
          desc: "Complete business establishment and administrative support in Europe.",
        },
        relocation: {
          title: "Elite Relocation",
          desc: "Dedicated management for a smooth transition into your new life.",
        },
        education: {
          title: "Education & Family",
          desc: "Planning for the future with family settlement and school placements.",
        },
        schengen: {
          title: "Schengen Support",
          desc: "Streamlined visa review and preparation for European travel.",
        },
        property: {
          title: "Luxury Real Estate",
          desc: "Exclusive access to premium properties in the Mediterranean.",
        },
        concierge: {
          title: "VIP Concierge",
          desc: "Lifestyle management and bespoke arrangements for the elite.",
        },
        egyptCategoryA: {
          title: "Egypt as You Have Never Seen It Before — Category A",
          desc: "5-star Egypt itinerary with Cairo, GEM, Pyramids, Nile cruise, Luxor and Aswan. Starting from $2,541 per person.",
        },
        egyptCategoryB: {
          title: "Egypt as You Have Never Seen It Before — Category B",
          desc: "4-star Egypt itinerary with Cairo, GEM, Pyramids, Nile cruise, Luxor and Aswan. Starting from $2,012 per person.",
        },
      },
    },
    ar: {
      pageTitle: "الخدمات المتميزة | FlyVia أسلوب الحياة العالمي",
      heroTitle: "خدماتنا",
      heroSubtitle:
        "مسارات شاملة للإقامة، والأعمال، والحياة النخبوية في أوروبا.",
      breadcrumbHome: "الرئيسية",
      breadcrumbCurrent: "خدماتنا",
      aviationHeader: "محفظة الطيران",
      relocationHeader: "خبراء الانتقال",
      lifestyleHeader: "أسلوب الحياة العالمي",
      travelHeader: "السياحة والسفر",
      services: {
        jet: {
          title: "طيران خاص",
          desc: "حلول طيران مخصصة لأولئك الذين يقدرون الوقت والخصوصية.",
        },
        emptyLeg: {
          title: "رحلات Empty Leg",
          desc: "فرص سفر متميزة على الطائرات المعاد تموضعها بقيمة استثنائية.",
        },
        commercial: {
          title: "رحلات تجارية",
          desc: "مزيج مميز من الكفاءة والراحة لأهم الوجهات.",
        },
        medEvac: {
          title: "الإخلاء الطبي",
          desc: "خدمات إسعاف جوي احترافية وعاجلة مع رعاية متخصصة.",
        },
        cargo: {
          title: "شحن خاص",
          desc: "خدمات لوجستية آمنة وعالية الأولوية للأصول القيمة.",
        },
        ads: {
          title: "إعلانات جوية",
          desc: "ارتقِ برؤية علامتك التجارية مع عروضنا الجوية الفريدة.",
        },
        flightSightseeingTour: {
          title: "جولات الطيران السياحية",
          desc: "استكشف روائع مصر من السماء فوق القاهرة والأهرامات والأقصر والجونة والغردقة.",
        },
        almazaVipTerminal: {
          title: "Almaza VIP Terminal",
          desc: "خدمات مغادرة ووصول حصرية للطائرات الخاصة مع خصوصية عالية وتجربة VIP سلسة وراقية.",
        },
        flightCrewTraining: {
          title: "تدريب طاقم الطيران",
          desc: "برامج تدريب طيران للطيارين والفنيين وطاقم الضيافة تشمل السلامة والتشغيل وجاهزية الخدمة.",
        },
        residency: {
          title: "الإقامة في إسبانيا",
          desc: "توجيه خبير عبر مسارات الإقامة والقوانين الإسبانية.",
        },
        nomad: {
          title: "فيزا الرحالة الرقمي",
          desc: "دعم استراتيجي للمهنيين عن بعد الساعين للحياة في إسبانيا.",
        },
        formation: {
          title: "تأسيس الشركات",
          desc: "دعم كامل لتأسيس الأعمال والإدارة في أوروبا.",
        },
        relocation: {
          title: "الانتقال المتميز",
          desc: "إدارة مخصصة لانتقال سلس إلى حياتك الجديدة.",
        },
        education: {
          title: "التعليم والعائلة",
          desc: "تخطيط للمستقبل مع استقرار العائلة والالتحاق بالمدارس.",
        },
        schengen: {
          title: "دعم الشنجن",
          desc: "مراجعة وتجهيز تأشيرات السفر الأوروبية بسلاسة.",
        },
        property: {
          title: "عقارات فاخرة",
          desc: "وصول حصري للعقارات المتميزة في البحر المتوسط.",
        },
        concierge: {
          title: "كونسيرج VIP",
          desc: "إدارة أسلوب الحياة وترتيبات مخصصة للنخبة.",
        },
        egyptCategoryA: {
          title: "مصر كما لم ترها من قبل — الفئة A",
          desc: "برنامج مصر 5 نجوم يشمل القاهرة والمتحف المصري الكبير والأهرامات ورحلة نيلية والأقصر وأسوان. يبدأ من 2,541 دولار للفرد.",
        },
        egyptCategoryB: {
          title: "مصر كما لم ترها من قبل — الفئة B",
          desc: "برنامج مصر 4 نجوم يشمل القاهرة والمتحف المصري الكبير والأهرامات ورحلة نيلية والأقصر وأسوان. يبدأ من 2,012 دولار للفرد.",
        },
      },
    },
  };

  const t = (path) => {
    const keys = path.split(".");
    let result = translations[isAR ? "ar" : "en"];

    for (const key of keys) {
      result = result?.[key];
    }

    return result || path;
  };

  const serviceCategories = useMemo(
    () => [
      {
        header: t("aviationHeader"),
        items: [
          {
            id: "jet",
            img: "/Gemini_Generated_Image_4pblo04pblo04pbl.png",
            title: t("services.jet.title"),
            desc: t("services.jet.desc"),
          },
          {
            id: "emptyLeg",
            img: "/empty-lag.jpeg",
            title: t("services.emptyLeg.title"),
            desc: t("services.emptyLeg.desc"),
          },
          {
            id: "commercial",
            img: "/commercial.jpeg",
            title: t("services.commercial.title"),
            desc: t("services.commercial.desc"),
          },
          {
            id: "medEvac",
            img: "/medical.jpeg",
            title: t("services.medEvac.title"),
            desc: t("services.medEvac.desc"),
          },
          {
            id: "cargo",
            img: "/cargo.jpeg",
            title: t("services.cargo.title"),
            desc: t("services.cargo.desc"),
          },
          {
            id: "ads",
            img: "/67bae2fe-43f7-4640-8848-2e038b92b118.png",
            title: t("services.ads.title"),
            desc: t("services.ads.desc"),
          },
          {
            id: "flight-sightseeing-tour",
            img: "/4460dff2-298b-4bd6-aa84-58ad35651c2b.png",
            title: t("services.flightSightseeingTour.title"),
            desc: t("services.flightSightseeingTour.desc"),
          },
          {
            id: "almaza-vip-terminal",
            img: "/almaza-vip-terminal.jpeg",
            title: t("services.almazaVipTerminal.title"),
            desc: t("services.almazaVipTerminal.desc"),
          },
        ],
      },
      {
        header: t("relocationHeader"),
        items: [
          {
            id: "residency",
            img: ResidencyImg,
            title: t("services.residency.title"),
            desc: t("services.residency.desc"),
          },
          {
            id: "nomad",
            img: RelocationImg,
            title: t("services.nomad.title"),
            desc: t("services.nomad.desc"),
          },
          {
            id: "formation",
            img: CompanyImg,
            title: t("services.formation.title"),
            desc: t("services.formation.desc"),
          },
          {
            id: "relocation",
            img: RelocationImg,
            title: t("services.relocation.title"),
            desc: t("services.relocation.desc"),
          },
          {
            id: "education",
            img: ResidencyImg,
            title: t("services.education.title"),
            desc: t("services.education.desc"),
          },
          {
            id: "schengen",
            img: RelocationImg,
            title: t("services.schengen.title"),
            desc: t("services.schengen.desc"),
          },
        ],
      },
      {
        header: t("lifestyleHeader"),
        items: [
          {
            id: "property",
            img: PropertyImg,
            title: t("services.property.title"),
            desc: t("services.property.desc"),
          },
          {
            id: "concierge",
            img: ConciergeImg,
            title: t("services.concierge.title"),
            desc: t("services.concierge.desc"),
          },
        ],
      },
      {
        header: t("travelHeader"),
        items: [
          {
            id: "egypt-category-a",
            img: "/egypt-category-a-card.webp",
            title: t("services.egyptCategoryA.title"),
            desc: t("services.egyptCategoryA.desc"),
          },
          {
            id: "egypt-category-b",
            img: "/egypt-category-b-card.webp",
            title: t("services.egyptCategoryB.title"),
            desc: t("services.egyptCategoryB.desc"),
          },
        ],
      },
    ],
    [currentLang],
  );

  useEffect(() => {
    if (!isInitialized) return;

    const ctx = gsap.context(() => {
      gsap.from(".reveal-up", {
        y: 30,
        opacity: 0,
        stagger: 0.1,
        duration: 0.8,
        ease: "power2.out",
      });

      gsap.from(".os-card-anim", {
        y: 40,
        opacity: 0,
        stagger: 0.1,
        duration: 0.8,
        ease: "power3.out",
        clearProps: "all",
      });
    }, containerRef);

    return () => ctx.revert();
  }, [isInitialized, activeTab]);

  if (!isInitialized) return null;

  return (
    <div
      className="ourservices-page"
      ref={containerRef}
      dir={isAR ? "rtl" : "ltr"}
    >
      <SEO
        title={t("heroTitle")}
        description={t("heroSubtitle")}
        keywords={
          isAR
            ? "خدمات طيران, إقامة إسبانيا, تأسيس شركات, كونسيرج, رحلات خاصة, برامج سياحية مصر, رحلات مصر"
            : "aviation services, Spain residency, company setup, VIP concierge, private jets Europe, Egypt itineraries, travel packages"
        }
      />

      <style>{`
        .ourservices-page {
          background: #fff;
          color: #07111f;
          font-family: var(--font-primary);
        }
        
        .page-banner {
          position: relative;
          height: 65vh;
          min-height: 400px;
          background:
            linear-gradient(rgba(7, 17, 31, 0.75), rgba(7, 17, 31, 0.8)),
            url(${HeroImg});
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          clip-path: polygon(0 0, 100% 0, 100% 88%, 50% 100%, 0 88%);
          margin-bottom: 40px;
        }

        @media (max-width: 768px) {
          .page-banner {
            height: 90vh !important;
            min-height: 600px !important;
          }
        }

        .banner-content h1 {
          font-family: var(--font-heading);
          font-size: clamp(40px, 6vw, 72px);
          font-weight: 300;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 4px;
        }

        .breadcrumbs {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          font-family: var(--font-secondary);
          font-size: 12px;
          margin-top: 20px;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          opacity: 0.7;
          color: #fff !important;
          text-decoration: none !important;
          transition: 0.3s !important;
        }

        .services-tabs-container {
          display: flex;
          justify-content: center;
          margin: 40px 0 80px;
          padding: 0 15px;
        }

        .services-tabs-nav {
          display: flex;
          background: #f8fafc;
          padding: 8px;
          border-radius: 100px;
          gap: 8px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 10px 30px -5px rgba(0,0,0,0.05);
          flex-wrap: wrap;
          justify-content: center;
          margin: auto !important;
        }

        .tab-btn {
          background: transparent;
          border: none;
          font-family: var(--font-secondary);
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: #94a3b8;
          padding: 14px 35px;
          border-radius: 100px;
          transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
          cursor: pointer;
          position: relative;
          z-index: 1;
        }

        .tab-btn:hover {
          color: #475569;
        }

        .tab-btn.active {
          background: #ae0001;
          color: #fff;
          box-shadow: 0 10px 20px -5px rgba(174, 0, 1, 0.3);
        }

        @media (max-width: 768px) {
          .tab-btn {
            padding: 8px 15px;
            font-size: 10px;
            letter-spacing: 1px;
            flex: 1 1 auto;
          }

          .services-tabs-nav {
            gap: 4px;
            padding: 4px;
            border-radius: 20px;
          }

          .banner-content h1 {
            font-size: 32px;
            letter-spacing: 2px;
          }
        }

        .tab-content-grid {
          position: relative;
          padding-bottom: 80px;
        }

        .os-card {
          position: relative;
          padding: 15px;
          text-align: center;
          margin-bottom: 50px;
          transition: transform 0.4s ease;
        }
        
        .os-frame {
          position: absolute;
          top: 50px;
          left: 5px;
          right: 5px;
          bottom: 10px;
          border: 1px solid rgba(174, 0, 1, 0.1);
          z-index: 0;
          transition: all 0.4s ease;
        }

        .os-card:hover .os-frame {
          top: 5px;
          border-color: rgba(174, 0, 1, 0.4);
        }

        .os-image-wrapper {
          position: relative;
          z-index: 1;
          width: 100%;
          aspect-ratio: 3/4;
          overflow: hidden;
          margin-bottom: 20px;
          box-shadow: 0 15px 30px rgba(0,0,0,0.08);
        }

        @media (max-width: 768px) {
          .os-image-wrapper {
            aspect-ratio: 16/9;
          }
        }

        .os-image-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 1.2s ease;
        }

        .os-card:hover .os-image-wrapper img {
          transform: scale(1.08);
        }

        .os-card-title {
          font-family: var(--font-heading);
          font-size: 22px;
          color: #07111f;
          margin-top: 15px;
          font-weight: 300;
        }
        
        .os-card-desc {
          font-family: var(--font-secondary);
          font-size: 13px;
          color: #64748b;
          margin-top: 8px;
          line-height: 1.6;
          max-width: 90%;
          margin-inline: auto;
        }
        
        .os-watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          max-width: 800px;
          opacity: 0.15;
          z-index: 0;
          pointer-events: none;
          filter: grayscale(100%) contrast(1.2);
        }
      `}</style>

      <section className="page-banner">
        <img src="/1.png" alt="" className="os-watermark" />
        <Container
          className="banner-content reveal-up"
          style={{ zIndex: 1, position: "relative" }}
        >
          <h1>{t("heroTitle")}</h1>
          <div className="breadcrumbs">
            <Link to="/" className="!text-white !no-underline">
              {t("breadcrumbHome")}
            </Link>
            {isAR ? <FaArrowLeft /> : <FaArrowRight />}
            <span className="!text-white !no-underline">
              {t("breadcrumbCurrent")}
            </span>
          </div>
        </Container>
      </section>

      <Container>
        <div className="services-tabs-nav !w-fit !justify-center mx-auto reveal-up">
          {serviceCategories.map((cat, idx) => (
            <button
              key={idx}
              className={`tab-btn ${activeTab === idx ? "active" : ""}`}
              onClick={() => setActiveTab(idx)}
            >
              {cat.header}
            </button>
          ))}
        </div>

        <div className="tab-content-grid">
          <Row>
            {serviceCategories[activeTab].items.map((item) => (
              <Col lg={4} md={6} key={item.id} className="os-card-anim">
                <Link
                  to={`/service/${item.id}`}
                  style={{ textDecoration: "none" }}
                >
                  <div className="os-card">
                    <div className="os-frame"></div>
                    <div className="os-image-wrapper">
                      <img src={item.img} alt={item.title} />
                    </div>
                    <h3 className="os-card-title">{item.title}</h3>
                    <p className="os-card-desc">{item.desc}</p>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
};
